/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Title_3Inputs */

const en_services_title_3 = /** @type {(inputs: Services_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run it all.`)
};

const lv_services_title_3 = /** @type {(inputs: Services_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzticiet visu.`)
};

/**
* | output |
* | --- |
* | "Run it all." |
*
* @param {Services_Title_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_title_3 = /** @type {((inputs?: Services_Title_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Title_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_title_3(inputs)
	return en_services_title_3(inputs)
});